import React, { Component } from 'react';
import * as PropTypes from 'prop-types';
import Button from 'components/Button';
import { NEXT_STEP, PREV_STEP } from './constants';
import { ReactComponent as ExitIcon } from 'images/ic-exit.svg';
import styles from './StepWizard.module.scss';
import Loading from 'components/Loading';

class StepWizardControls extends Component {
  getCurrentStepIndex() {
    const { steps, currentStep } = this.props;
    return steps.findIndex(({ key }) => key === currentStep.key);
  }

  goToNext = () => {
    const { onStepChange, steps } = this.props;
    const currentStepIndex = this.getCurrentStepIndex();
    const nextStepIndex =
      !!~currentStepIndex && currentStepIndex + 1 < steps.length
        ? currentStepIndex + 1
        : currentStepIndex;
    onStepChange(steps[nextStepIndex] && steps[nextStepIndex].key, NEXT_STEP, true);
  };

  goToPrev = () => {
    const { onStepChange, steps } = this.props;
    const currentStepIndex = this.getCurrentStepIndex();
    const nextStepIndex =
      !!~currentStepIndex && currentStepIndex - 1 >= 0 ? currentStepIndex - 1 : currentStepIndex;

    onStepChange(steps[nextStepIndex] && steps[nextStepIndex].key, PREV_STEP);
  };

  isFirstStep = () => this.getCurrentStepIndex() === 0;

  render() {
    const {
      inTransition,
      onExit,
      currentStep: { buttonText = 'Далее' },
    } = this.props;
    return (
      <div className={`${styles.controls} boo`}>
        <div className="d-flex w-100 justify-content-between flex-column flex-sm-row">
          <Button
            type={'button'}
            hasWrapper={false}
            extraClassName={styles.button}
            isDisabled={inTransition}
            onClick={onExit}
            isLinkStyled={true}
          >
            <ExitIcon className={styles.icon} />
            Выйти
          </Button>

          <div className="mt-4 mt-sm-0">
            {!this.isFirstStep() && (
              <Button
                type={'button'}
                hasWrapper={false}
                onClick={this.goToPrev}
                extraClassName={`${styles.button} ${styles.prev}`}
                isDisabled={inTransition}
                color={'white'}
              >
                Назад
              </Button>
            )}
            <Button
              type={'button'}
              hasWrapper={false}
              onClick={this.goToNext}
              extraClassName={`${styles.button} ${styles.next}`}
              isDisabled={inTransition}
            >
              {inTransition && (
                <span className={styles.iconLoading}>
                  <Loading size={'sm'} isLight />
                </span>
              )}
              {buttonText}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

StepWizardControls.propTypes = {
  onStepChange: PropTypes.func.isRequired,
  steps: PropTypes.array,
  currentStep: PropTypes.object.isRequired,
  inTransition: PropTypes.bool,
  onExit: PropTypes.func,
};

export default StepWizardControls;
